import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useGlobalContext } from '@/store';

export function SuccessModal() {
  const { successModal, closeSuccessModal } = useGlobalContext();

  return (
    <Dialog open={successModal.show} onClose={closeSuccessModal} maxWidth="xs" fullWidth>
      <DialogTitle className="text-green-600">Success</DialogTitle>
      <DialogContent>
        <Typography>{successModal.title}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeSuccessModal} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
